/**
 * @generated SignedSource<<b8b515a3cdc150ca4dc830ae3d35a23d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteInternalDocumentMutationInput = {
  clientMutationId?: string | null;
  internalDocumentId: string;
};
export type InternalDocumentListDeleteMutation$variables = {
  input: DeleteInternalDocumentMutationInput;
};
export type InternalDocumentListDeleteMutation$data = {
  readonly deleteInternalDocument: {
    readonly success: boolean | null;
  } | null;
};
export type InternalDocumentListDeleteMutation = {
  response: InternalDocumentListDeleteMutation$data;
  variables: InternalDocumentListDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInternalDocumentMutationPayload",
    "kind": "LinkedField",
    "name": "deleteInternalDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalDocumentListDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternalDocumentListDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99fe294aaf66f5c89fab087b4d48982f",
    "id": null,
    "metadata": {},
    "name": "InternalDocumentListDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation InternalDocumentListDeleteMutation(\n  $input: DeleteInternalDocumentMutationInput!\n) {\n  deleteInternalDocument(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "2749ee23f852b0a1d70d59194bcaf233";

export default node;
